/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiV1AuthActivateAccountPost } from '../fn/auth/api-v-1-auth-activate-account-post';
import { ApiV1AuthActivateAccountPost$Params } from '../fn/auth/api-v-1-auth-activate-account-post';
import { apiV1AuthChangePasswordPost } from '../fn/auth/api-v-1-auth-change-password-post';
import { ApiV1AuthChangePasswordPost$Params } from '../fn/auth/api-v-1-auth-change-password-post';
import { apiV1AuthForgotPasswordPost } from '../fn/auth/api-v-1-auth-forgot-password-post';
import { ApiV1AuthForgotPasswordPost$Params } from '../fn/auth/api-v-1-auth-forgot-password-post';
import { apiV1AuthLogin2FaVerifyPost } from '../fn/auth/api-v-1-auth-login-2-fa-verify-post';
import { ApiV1AuthLogin2FaVerifyPost$Params } from '../fn/auth/api-v-1-auth-login-2-fa-verify-post';
import { apiV1AuthLoginPost } from '../fn/auth/api-v-1-auth-login-post';
import { ApiV1AuthLoginPost$Params } from '../fn/auth/api-v-1-auth-login-post';
import { apiV1AuthLogoutPost } from '../fn/auth/api-v-1-auth-logout-post';
import { ApiV1AuthLogoutPost$Params } from '../fn/auth/api-v-1-auth-logout-post';
import { apiV1AuthMeGet } from '../fn/auth/api-v-1-auth-me-get';
import { ApiV1AuthMeGet$Params } from '../fn/auth/api-v-1-auth-me-get';
import { apiV1AuthRefreshTokenPost } from '../fn/auth/api-v-1-auth-refresh-token-post';
import { ApiV1AuthRefreshTokenPost$Params } from '../fn/auth/api-v-1-auth-refresh-token-post';
import { apiV1AuthRegisterPost } from '../fn/auth/api-v-1-auth-register-post';
import { ApiV1AuthRegisterPost$Params } from '../fn/auth/api-v-1-auth-register-post';
import { apiV1AuthResendActivationPost } from '../fn/auth/api-v-1-auth-resend-activation-post';
import { ApiV1AuthResendActivationPost$Params } from '../fn/auth/api-v-1-auth-resend-activation-post';
import { apiV1AuthResetPasswordPost } from '../fn/auth/api-v-1-auth-reset-password-post';
import { ApiV1AuthResetPasswordPost$Params } from '../fn/auth/api-v-1-auth-reset-password-post';
import { AuthUserResponse as ModelsAuthUserResponse } from '../models/models/auth-user-response';
import { SuccessResponse as ModelsSuccessResponse } from '../models/models/success-response';

@Injectable({ providedIn: 'root' })
export class AuthService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiV1AuthActivateAccountPost()` */
  static readonly ApiV1AuthActivateAccountPostPath = '/api/v1/auth/activate-account';

  /**
   * Activate account.
   *
   * Activates a registered user account using the email activation token.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1AuthActivateAccountPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1AuthActivateAccountPost$Response(params: ApiV1AuthActivateAccountPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsSuccessResponse>> {
    const obs = apiV1AuthActivateAccountPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Activate account.
   *
   * Activates a registered user account using the email activation token.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1AuthActivateAccountPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1AuthActivateAccountPost(params: ApiV1AuthActivateAccountPost$Params, context?: HttpContext): Observable<ModelsSuccessResponse> {
    const resp = this.apiV1AuthActivateAccountPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ModelsSuccessResponse>): ModelsSuccessResponse => r.body)
    );
  }

  /** Path part for operation `apiV1AuthChangePasswordPost()` */
  static readonly ApiV1AuthChangePasswordPostPath = '/api/v1/auth/change-password';

  /**
   * Change password.
   *
   * Changes the authenticated user's password and returns fresh login tokens.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1AuthChangePasswordPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1AuthChangePasswordPost$Response(params: ApiV1AuthChangePasswordPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsSuccessResponse>> {
    const obs = apiV1AuthChangePasswordPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Change password.
   *
   * Changes the authenticated user's password and returns fresh login tokens.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1AuthChangePasswordPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1AuthChangePasswordPost(params: ApiV1AuthChangePasswordPost$Params, context?: HttpContext): Observable<ModelsSuccessResponse> {
    const resp = this.apiV1AuthChangePasswordPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ModelsSuccessResponse>): ModelsSuccessResponse => r.body)
    );
  }

  /** Path part for operation `apiV1AuthForgotPasswordPost()` */
  static readonly ApiV1AuthForgotPasswordPostPath = '/api/v1/auth/forgot-password';

  /**
   * Request password reset.
   *
   * Sends a password reset email when the account exists and is active.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1AuthForgotPasswordPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1AuthForgotPasswordPost$Response(params: ApiV1AuthForgotPasswordPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsSuccessResponse>> {
    const obs = apiV1AuthForgotPasswordPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Request password reset.
   *
   * Sends a password reset email when the account exists and is active.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1AuthForgotPasswordPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1AuthForgotPasswordPost(params: ApiV1AuthForgotPasswordPost$Params, context?: HttpContext): Observable<ModelsSuccessResponse> {
    const resp = this.apiV1AuthForgotPasswordPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ModelsSuccessResponse>): ModelsSuccessResponse => r.body)
    );
  }

  /** Path part for operation `apiV1AuthLoginPost()` */
  static readonly ApiV1AuthLoginPostPath = '/api/v1/auth/login';

  /**
   * Login.
   *
   * Authenticates with email or username. Returns tokens or a 2FA challenge when 2FA is enabled.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1AuthLoginPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1AuthLoginPost$Response(params: ApiV1AuthLoginPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsSuccessResponse>> {
    const obs = apiV1AuthLoginPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Login.
   *
   * Authenticates with email or username. Returns tokens or a 2FA challenge when 2FA is enabled.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1AuthLoginPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1AuthLoginPost(params: ApiV1AuthLoginPost$Params, context?: HttpContext): Observable<ModelsSuccessResponse> {
    const resp = this.apiV1AuthLoginPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ModelsSuccessResponse>): ModelsSuccessResponse => r.body)
    );
  }

  /** Path part for operation `apiV1AuthLogin2FaVerifyPost()` */
  static readonly ApiV1AuthLogin2FaVerifyPostPath = '/api/v1/auth/login/2fa/verify';

  /**
   * Verify login 2FA.
   *
   * Verifies an email OTP or TOTP challenge and returns login tokens.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1AuthLogin2FaVerifyPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1AuthLogin2FaVerifyPost$Response(params: ApiV1AuthLogin2FaVerifyPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsSuccessResponse>> {
    const obs = apiV1AuthLogin2FaVerifyPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Verify login 2FA.
   *
   * Verifies an email OTP or TOTP challenge and returns login tokens.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1AuthLogin2FaVerifyPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1AuthLogin2FaVerifyPost(params: ApiV1AuthLogin2FaVerifyPost$Params, context?: HttpContext): Observable<ModelsSuccessResponse> {
    const resp = this.apiV1AuthLogin2FaVerifyPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ModelsSuccessResponse>): ModelsSuccessResponse => r.body)
    );
  }

  /** Path part for operation `apiV1AuthLogoutPost()` */
  static readonly ApiV1AuthLogoutPostPath = '/api/v1/auth/logout';

  /**
   * Logout.
   *
   * Revokes the supplied refresh token for the authenticated user.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1AuthLogoutPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1AuthLogoutPost$Response(params?: ApiV1AuthLogoutPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsSuccessResponse>> {
    const obs = apiV1AuthLogoutPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Logout.
   *
   * Revokes the supplied refresh token for the authenticated user.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1AuthLogoutPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1AuthLogoutPost(params?: ApiV1AuthLogoutPost$Params, context?: HttpContext): Observable<ModelsSuccessResponse> {
    const resp = this.apiV1AuthLogoutPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ModelsSuccessResponse>): ModelsSuccessResponse => r.body)
    );
  }

  /** Path part for operation `apiV1AuthMeGet()` */
  static readonly ApiV1AuthMeGetPath = '/api/v1/auth/me';

  /**
   * Get current user.
   *
   * Returns the authenticated user's profile, roles, and permissions.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1AuthMeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1AuthMeGet$Response(params?: ApiV1AuthMeGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthUserResponse>> {
    const obs = apiV1AuthMeGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get current user.
   *
   * Returns the authenticated user's profile, roles, and permissions.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1AuthMeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1AuthMeGet(params?: ApiV1AuthMeGet$Params, context?: HttpContext): Observable<ModelsAuthUserResponse> {
    const resp = this.apiV1AuthMeGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ModelsAuthUserResponse>): ModelsAuthUserResponse => r.body)
    );
  }

  /** Path part for operation `apiV1AuthRefreshTokenPost()` */
  static readonly ApiV1AuthRefreshTokenPostPath = '/api/v1/auth/refresh-token';

  /**
   * Refresh token.
   *
   * Rotates a refresh token and returns a new access token and refresh token.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1AuthRefreshTokenPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1AuthRefreshTokenPost$Response(params: ApiV1AuthRefreshTokenPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsSuccessResponse>> {
    const obs = apiV1AuthRefreshTokenPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Refresh token.
   *
   * Rotates a refresh token and returns a new access token and refresh token.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1AuthRefreshTokenPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1AuthRefreshTokenPost(params: ApiV1AuthRefreshTokenPost$Params, context?: HttpContext): Observable<ModelsSuccessResponse> {
    const resp = this.apiV1AuthRefreshTokenPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ModelsSuccessResponse>): ModelsSuccessResponse => r.body)
    );
  }

  /** Path part for operation `apiV1AuthRegisterPost()` */
  static readonly ApiV1AuthRegisterPostPath = '/api/v1/auth/register';

  /**
   * Register a user.
   *
   * Creates an inactive USER account and sends an email activation link.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1AuthRegisterPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1AuthRegisterPost$Response(params: ApiV1AuthRegisterPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsSuccessResponse>> {
    const obs = apiV1AuthRegisterPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Register a user.
   *
   * Creates an inactive USER account and sends an email activation link.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1AuthRegisterPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1AuthRegisterPost(params: ApiV1AuthRegisterPost$Params, context?: HttpContext): Observable<ModelsSuccessResponse> {
    const resp = this.apiV1AuthRegisterPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ModelsSuccessResponse>): ModelsSuccessResponse => r.body)
    );
  }

  /** Path part for operation `apiV1AuthResendActivationPost()` */
  static readonly ApiV1AuthResendActivationPostPath = '/api/v1/auth/resend-activation';

  /**
   * Resend activation email.
   *
   * Sends a fresh account activation email for an inactive account.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1AuthResendActivationPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1AuthResendActivationPost$Response(params: ApiV1AuthResendActivationPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsSuccessResponse>> {
    const obs = apiV1AuthResendActivationPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Resend activation email.
   *
   * Sends a fresh account activation email for an inactive account.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1AuthResendActivationPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1AuthResendActivationPost(params: ApiV1AuthResendActivationPost$Params, context?: HttpContext): Observable<ModelsSuccessResponse> {
    const resp = this.apiV1AuthResendActivationPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ModelsSuccessResponse>): ModelsSuccessResponse => r.body)
    );
  }

  /** Path part for operation `apiV1AuthResetPasswordPost()` */
  static readonly ApiV1AuthResetPasswordPostPath = '/api/v1/auth/reset-password';

  /**
   * Reset password.
   *
   * Resets a password using a valid reset token.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1AuthResetPasswordPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1AuthResetPasswordPost$Response(params: ApiV1AuthResetPasswordPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsSuccessResponse>> {
    const obs = apiV1AuthResetPasswordPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Reset password.
   *
   * Resets a password using a valid reset token.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1AuthResetPasswordPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1AuthResetPasswordPost(params: ApiV1AuthResetPasswordPost$Params, context?: HttpContext): Observable<ModelsSuccessResponse> {
    const resp = this.apiV1AuthResetPasswordPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ModelsSuccessResponse>): ModelsSuccessResponse => r.body)
    );
  }

}
